import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
const StateIcon = ({ name, color = 'text-color-light', className = 'text-size-300pct' }) => (_jsx("span", { className: `rioglyph ${name} ${color} ${className}` }));
export default StateIcon;
